import React, { Component } from "react";
import { Spin, Select } from "antd";
import axios from "axios";
import debounce from "lodash.debounce";
import { connect } from "react-redux";
import './Styles.css';

const { Option } = Select;

// Clientes de la empresa emisora de BIWO (cobro del sistema)
class SelectClientesEmisoraBiwoItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opciones: [],
      cargando: false,
      primerCarga: false,
      texto: '',
    };

    this.buscarClientes = debounce(this.buscarClientes.bind(this), 300);
  }

  componentDidMount() {
    this.buscarClientes('', true);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value && this.props.value) {
      const clienteEnEstado = this.state.opciones.find(cliente => cliente._id.toString() === this.props.value.toString());
      if (!clienteEnEstado) this.buscarClientes(this.props.value, true);
    }
  }

  componentWillUnmount() {
    if (this.buscarClientes && this.buscarClientes.cancel) this.buscarClientes.cancel();
  }

  async buscarClientes(texto, primerCarga, append = false) {
    this.setState({ cargando: true, primerCarga: primerCarga && this.esIdMongoDB(texto) });
    try {
      const res = await axios.post(
        "cobroBiwo/selectClientesEmisora",
        {
          query: append ? (this.state.texto || texto) : (texto || this.props.value),
          skip: append ? this.state.opciones.length : 0,
        },
        { headers: this.props.headersToken }
      );

      if (res.data.success === 2) {
        const nuevas = append ? [...this.state.opciones, ...res.data.clientes] : res.data.clientes;
        this.setState({ opciones: nuevas, primerCarga: false });
      } else {
        this.setState({ opciones: [] });
      }
    } catch (error) {
      console.error("Error al buscar clientes:", error);
      this.setState({ opciones: [] });
    } finally {
      this.setState({ cargando: false, texto: append ? this.state.texto : texto });
    }
  }

  esIdMongoDB(valor) {
    return valor && typeof valor === 'string' && /^[0-9a-fA-F]{24}$/.test(valor);
  }

  render() {
    const { noBuscar, disabled, fondoBlanco, sinBorde, width, style, placeholder, headersToken, dispatch, ...restProps } = this.props;

    let valorMostrado = this.props.value;
    let placeholderMostrado = placeholder || "Cliente de la empresa emisora";
    if (this.esIdMongoDB(this.props.value) && !this.state.opciones.find(cliente => cliente._id === this.props.value)) {
      valorMostrado = undefined;
      placeholderMostrado = this.state.cargando ? "Buscando cliente..." : "Cargando...";
    }

    const estiloFinal = {
      color: disabled ? 'black' : 'inherit',
      backgroundColor: disabled ? (fondoBlanco ? 'white' : 'white') : null,
      borderBottom: sinBorde ? 'none' : '1px solid #E0FFFFFF',
      borderRadius: '4px',
      transition: 'border-color 0.3s ease',
      boxShadow: sinBorde ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.1)',
      width: width || undefined,
      opacity: disabled ? 1 : undefined,
      ...style,
    };

    return (
      <Select
        className={`custom-disabled-select ${disabled ? "custom-disabled" : ""}`}
        dropdownMatchSelectWidth={400}
        disabled={disabled || this.state.primerCarga}
        dropdownRender={(menu) => <Spin spinning={this.state.cargando}>{menu}</Spin>}
        showSearch={!noBuscar}
        filterOption={false}
        onSearch={this.buscarClientes}
        loading={this.state.cargando}
        allowClear
        notFoundContent={this.state.cargando ? "Buscando clientes..." : "Sin clientes en la empresa emisora"}
        {...restProps}
        value={valorMostrado}
        onChange={(value) => {
          const cliente = this.state.opciones.find((cliente) => cliente._id === value);
          if (this.props.onChange) this.props.onChange(value, cliente);
        }}
        placeholder={placeholderMostrado}
        style={estiloFinal}
        bordered={false}
        onPopupScroll={(e) => {
          const { target } = e;
          if (target.scrollTop + target.offsetHeight === target.scrollHeight) this.buscarClientes('', false, true);
        }}
      >
        {this.state.opciones.map((cliente) => (
          <Option key={cliente._id} value={cliente._id}>
            {cliente.stringBuscar}
          </Option>
        ))}
      </Select>
    );
  }
}

const mapStateToProps = (state) => ({ headersToken: state.user.headersToken });

export default connect(mapStateToProps)(SelectClientesEmisoraBiwoItem);
